/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Aiflowstartprice3Inputs */

const en_aiflowstartprice3 = /** @type {(inputs: Aiflowstartprice3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filling in costs ${i?.credits} credits.`)
};

const de_aiflowstartprice3 = /** @type {(inputs: Aiflowstartprice3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ausfüllen kostet ${i?.credits} Credits.`)
};

/**
* | output |
* | --- |
* | "Filling in costs {credits} credits." |
*
* @param {Aiflowstartprice3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstartprice3 = /** @type {((inputs: Aiflowstartprice3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstartprice3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstartprice3(inputs)
	return de_aiflowstartprice3(inputs)
});
export { aiflowstartprice3 as "aiFlowStartPrice" }